import React from 'react';
import { useNavigate } from 'react-router-dom';
import GradientButton from '../../../../components/buttons/GradientButton';
import { buildSettingsSectionPath } from '../../../../components/settings/section-paths/settingsSectionPaths';
import './manual-booking-empty-services.css';

const COPY = {
  none: {
    title: 'No services available',
    body: 'Add a service before you can book a manual appointment.',
    hint: 'Assign at least one staff member to the service so it can be booked.',
    crumbs: ['Settings', 'Services', 'New Service'],
    primaryLabel: 'Go to Services',
  },
  'no-staff': {
    title: 'Services need assigned staff',
    body: 'You have services, but none have staff assigned yet.',
    hint: 'Open a service and assign employees so it can be booked.',
    crumbs: ['Settings', 'Services'],
    primaryLabel: 'Go to Services',
  },
  location: {
    title: 'No services at this location',
    body: 'None of your services are offered at the location you selected.',
    hint: 'Add this location on a service, or go back and choose another location.',
    crumbs: ['Settings', 'Services'],
    primaryLabel: 'Go to Services',
  },
};

const ServiceMarkIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7.5 7.5h9M7.5 12h6M6 4.5h12A1.5 1.5 0 0 1 19.5 6v12A1.5 1.5 0 0 1 18 19.5H6A1.5 1.5 0 0 1 4.5 18V6A1.5 1.5 0 0 1 6 4.5Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <path
      d="M15.2 15.2 18 18"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <circle cx="13.4" cy="13.4" r="2.2" stroke="currentColor" strokeWidth="1.7" />
  </svg>
);

const ManualBookingEmptyServices = ({ reason = 'none' }) => {
  const navigate = useNavigate();
  const copy = COPY[reason] || COPY.none;

  const openServices = () => {
    navigate(buildSettingsSectionPath('services-categories'));
  };

  return (
    <div className="mb-empty-services">
      <div className="mb-empty-services__card" role="status">
        <div className="mb-empty-services__icon">
          <ServiceMarkIcon />
        </div>
        <h3 className="mb-empty-services__title">{copy.title}</h3>
        <p className="mb-empty-services__copy">{copy.body}</p>
        <div className="mb-empty-services__path" aria-label="Where to add services">
          {copy.crumbs.map((crumb, index) => (
            <React.Fragment key={crumb}>
              {index > 0 ? <span className="mb-empty-services__sep" aria-hidden="true">→</span> : null}
              <span className="mb-empty-services__crumb">{crumb}</span>
            </React.Fragment>
          ))}
        </div>
        <div className="mb-empty-services__actions">
          <GradientButton onClick={openServices}>
            {copy.primaryLabel}
          </GradientButton>
        </div>
        <p className="mb-empty-services__hint">{copy.hint}</p>
      </div>
    </div>
  );
};

export default ManualBookingEmptyServices;
